mutation UpdateInvestmentPool($investmentPoolInput: InvestmentPoolInput!) {
  updateInvestmentPool(input: { investmentPoolInput: $investmentPoolInput }) {
    investmentPool {
      id
      name
      isActive
      accountNumber
      salesforceId
      legalEntity {
        id
        name
      }
      currency
      opexFloatFundAccount {
        id
        fund {
          id
          name
          legalEntity {
            id
            name
          }
        }
        currency
      }
    }
  }
}
